/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

import type { PublisherDTO } from './PublisherDTO';
import {
    PublisherDTOFromJSON,
    PublisherDTOFromJSONTyped,
    PublisherDTOToJSON,
    PublisherDTOToJSONTyped,
} from './PublisherDTO';
import type { WorkPublisherPlaceDTO } from './WorkPublisherPlaceDTO';
import {
    WorkPublisherPlaceDTOFromJSON,
    WorkPublisherPlaceDTOFromJSONTyped,
    WorkPublisherPlaceDTOToJSON,
    WorkPublisherPlaceDTOToJSONTyped,
} from './WorkPublisherPlaceDTO';

/**
 * 
 * @export
 * @interface WorkPublisherDTO
 */
export interface WorkPublisherDTO  {
    /**
     * 
     * @type {number}
     * @memberof WorkPublisherDTO
     */
    id?: number;
    /**
     * 
     * @type {PublisherDTO}
     * @memberof WorkPublisherDTO
     */
    publisher?: PublisherDTO;
    /**
     * 
     * @type {Array<WorkPublisherPlaceDTO>}
     * @memberof WorkPublisherDTO
     */
    workPublisherPlace?: Array<WorkPublisherPlaceDTO>;
}

/**
 * Check if a given object implements the WorkPublisherDTO interface.
 */
export function instanceOfWorkPublisherDTO(value: object): value is WorkPublisherDTO {
    return true;
}

export function WorkPublisherDTOFromJSON(json: any): WorkPublisherDTO {
    return WorkPublisherDTOFromJSONTyped(json, false);
}

export function WorkPublisherDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkPublisherDTO {
    if (json == null) {
        return json;
    }
    return {
        
                  'id': json['id'] == null ? undefined : json['id'],
                  'publisher': json['publisher'] == null ? undefined : PublisherDTOFromJSON(json['publisher']),
              'workPublisherPlace': json['workPublisherPlace'] == null ? undefined : ((json['workPublisherPlace'] as Array<any>).map(WorkPublisherPlaceDTOFromJSON)),
    };
}

export function WorkPublisherDTOToJSON(json: any): WorkPublisherDTO {
    return WorkPublisherDTOToJSONTyped(json, false);
}

export function WorkPublisherDTOToJSONTyped(value?: WorkPublisherDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'publisher': PublisherDTOToJSON(value['publisher']),
        'workPublisherPlace': value['workPublisherPlace'] == null? value['workPublisherPlace']: (value['workPublisherPlace'] as Array<any>).map(WorkPublisherPlaceDTOToJSON),
    };
}


